import React, {Component, Fragment} from 'react';

import ApiService from "./ApiService";
import {PrimaryButton, TextField, Toggle} from "office-ui-fabric-react";
import moment from "moment";

interface AdminAssignmentAnalyticsSeedControlsProps {
    tenantName: string,
    schoolCode: string,
    apiService: ApiService;
    academicYear: number;
    startDate: string | undefined;
    endDate: string |  undefined;
}

interface AdminAssignmentAnalyticsSeedControlsState {
    maxPerDay: number; 
    dryRun: boolean;
}

export class AdminAssignmentAnalyticsSeedControls extends Component<AdminAssignmentAnalyticsSeedControlsProps, AdminAssignmentAnalyticsSeedControlsState> {
    
    constructor(props: AdminAssignmentAnalyticsSeedControlsProps) {
        super(props);

        this.state = {
            maxPerDay: 10,
            dryRun: true
        };
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: AdminAssignmentAnalyticsSeedControlsProps, prevState: AdminAssignmentAnalyticsSeedControlsState): Promise<void> {
    }
    
    render() {
        return (
            <Fragment>
                <TextField className="card__input"
                           label="Max per day"
                           type={"number"}
                           value={this.state.maxPerDay.toString()}
                           onChange={(e,v) => {
                               this.setState({maxPerDay: Number.parseInt(v!)});
                           }} />

                <Toggle
                    inlineLabel={true}
                    checked={this.state.dryRun}
                    onChange={(event, newValue) => {
                        this.setState({
                            dryRun: !this.state.dryRun
                        });
                    }}
                    role="switch"
                    label={"Dry run"}
                />
                <PrimaryButton onClick={async () => {
                    try
                    {
                        const input = {
                            academicYear: this.props.academicYear,
                            startDate: moment(this.props.startDate).toDate(),
                            endDate: moment(this.props.endDate).toDate(),
                            maxPerDay: this.state.maxPerDay,
                            dryRun: this.state.dryRun,
                        };
                        const instance = await this.props.apiService.triggerWorkloadWithInput(this.props.tenantName, this.props.schoolCode,"DevAndDemoSeedAssignments",input);
                        console.log(instance);
                        window.open(`/cdb-admin/workloads/${instance.durableFunctionInstanceId}`);
                    }
                    catch(e)
                    {
                        console.log(e);
                    }

                }} text="Start workload" />
            </Fragment>
        );
    }
}